export const ssoClientIds = {
  dev: '0oa112ohjqa3AMySG0h8',
  rc: '0oa112o9qwqapudTj0h8',
  production: '0oabkm6pplhH97PEz357',
};
